// Models for drug classes

import { Model } from "@vuex-orm/core";

export class DrugClass extends Model {
  static entity = 'drugClasses'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      label: this.string(),
    }
  }
}

export class DrugTree extends Model {
  static entity = 'drugTree'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      tree: this.attr([])
    }
  }
}